import { render } from "./WumaPage.vue?vue&type=template&id=239a7d54&scoped=true"
import script from "./WumaPage.vue?vue&type=script&lang=js"
export * from "./WumaPage.vue?vue&type=script&lang=js"

import "./WumaPage.vue?vue&type=style&index=0&id=239a7d54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239a7d54"]])

export default __exports__